import React from 'react';
import moment from 'moment';
import ContractOwnershipList from 'src/models/ContractOwnershipList';

export interface IAttachLeaseholdCardProps {
    onNavigate: (contractId: number, contractholdId: number, contractType: string) => void;
}

export type IAttachLeaseholdCardStateProps = {
    agreement: ContractOwnershipList;
    index: number;
    newAgreement: boolean;
    nav: boolean;
};

type IAttachLeaseholdCardPageProps = IAttachLeaseholdCardProps & IAttachLeaseholdCardStateProps;

const AttachLeaseholdCard = (props: IAttachLeaseholdCardPageProps) => {
    return (
            <div
                style={{ backgroundColor: props.agreement.isActiveLease ? '#ffff7d' : 'white', borderBottom: '1px solid grey', padding: '.5rem', display: 'flex' }}
                onClick={
                    !props.newAgreement
                        ? () => props.onNavigate(props.agreement.agreementId, props.agreement.agreementholdId, props.agreement.agreementType)
                        : () => props.onNavigate(props.agreement.agreementId, 0, props.agreement.agreementType)
                }
                className={props.nav ? 'clickable' : undefined}
                key={props.index}
            >
                <div style={{ width: '12%' }}>{props.agreement.agreementType || 'N/A'}</div>

                <div style={{ width: '10%' }}>{props.agreement.agreementNumber ? props.agreement.agreementNumber : props.agreement.leaseNumber || 'N/A'}</div>

                <div style={{ width: '10%' }}>{`${props.agreement.volume} / ${props.agreement.page}`}</div>

                <div style={{ width: '10%' }}>{props.agreement.agreementDate ? moment(props.agreement.agreementDate)?.format('MM/DD/YYYY') : 'N/A'}</div>

                <div style={{ width: '21%' }}>{props.agreement.originalLessor || 'N/A'}</div>

                <div style={{ width: '21%' }}>{props.agreement.originalLessee || 'N/A'}</div>

                <div style={{ width: '14%' }}>{props.agreement.isTopLease ? 'Top Lease' : props.agreement.isActiveLease ? 'Active' : 'Historical'}</div>
            </div>
    );
};

export default AttachLeaseholdCard;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ManageLeaseholdDialogComponents/AttachLeaseholdCard.tsx